<!-- Main sidebar -->
<div id="sidebar-tool" class="sidebar sidebar-dark sidebar-main sidebar-expand-lg sidebar-main-resized">
    <div class="sidebar-overlay bg-opacity-30"></div>
    <!-- Sidebar header -->
    <div id="wp-sidebar-main"
         class="sidebar-section bg-black bg-opacity-10 border-bottom border-bottom-white border-opacity-10">
        <div class="sidebar-logo d-flex justify-content-center align-items-center">
            <a [routerLink]="['/']" class="d-inline-flex align-items-center">
                <img [src]="logoDfUrlMini" class="sidebar-logo-icon" alt="logo"/>
                <img [src]="logoDef" class="sidebar-resize-hide" alt="logo"/>
            </a>
            <div class="sidebar-resize-hide ms-auto d-lg-none">
                <button type="button"
                        class="btn btn-flat-white btn-icon btn-sm rounded-pill border-transparent sidebar-control sidebar-main-resize d-none d-lg-inline-flex">
                    <i class="ph-arrows-left-right"></i>
                </button>
                <button type="button"
                        class="btn btn-flat-white btn-icon btn-sm rounded-pill border-transparent sidebar-mobile-main-toggle d-lg-none">
                    <i class="ph-x"></i>
                </button>
            </div>
        </div>
    </div>
    <!-- /sidebar header -->
    <!-- Sidebar content -->
    <div class="sidebar-content">
        <!-- Main navigation -->
        <div class="sidebar-section">
            <ul class="nav nav-sidebar" data-nav-type="accordion">
                <li class="nav-item">
                    <a [routerLink]="['/', 'home']"
                       [routerLinkActive]="'active'"
                       class="nav-link popover-item"
                       data-bs-toggle="popover"
                       data-bs-placement="right"
                       data-bs-trigger="hover"
                       [attr.data-bs-content]="'sideBar.home' | translate">
                        <i class="ph-house"></i>
                        <span>{{ 'sideBar.home' | translate }}</span>
                    </a>
                </li>
                <!-- Main -->
                <li class="nav-item-header">
                    <div class="text-uppercase fs-sm lh-sm opacity-50 sidebar-resize-hide">Main</div>
                    <i class="ph-dots-three sidebar-resize-show"></i>
                </li>
                <li class="nav-item" *ngIf="ruleCheckerService.isAllow('booking/overview')">
                    <a [routerLink]="['/', 'analytics', 'booking']"
                       class="nav-link popover-item"
                       data-bs-toggle="popover"
                       data-bs-placement="right"
                       data-bs-trigger="hover"
                       [attr.data-bs-content]="'sideBar.analytics.bookingStatistics' | translate">
                        <i class="ph ph-chart-line-up"></i>
                        <span>{{ 'sideBar.analytics.bookingStatistics' | translate }}</span></a>
                </li>

                <!--<li class="nav-item" *ngIf="ruleCheckerService.isAllow('audienceAssign/manage')">
                    <a [routerLink]="['/', 'assign-audience', 'manage']"
                       [routerLinkActive]="'active'"
                       class="nav-link popover-item"
                       data-bs-toggle="popover"
                       data-bs-placement="right"
                       data-bs-trigger="hover"
                       [attr.data-bs-content]="'Thống kê thực chạy' | translate">
                        <i class="ph ph-chart-line"></i>
                        <span>{{ 'Thống kê thực chạy' | translate }}</span></a>
                </li>

                <li class="nav-item" *ngIf="ruleCheckerService.isAllow('zone/list')">
                    <a [routerLink]="['/', 'zone-mapping', 'manage']"
                       [routerLinkActive]="'active'"
                       class="nav-link popover-item"
                       data-bs-toggle="popover"
                       data-bs-placement="right"
                       data-bs-trigger="hover"
                       [attr.data-bs-content]="'Thống kê hợp đồng' | translate">
                        <i class="ph ph-chart-bar"></i>
                        <span>{{ 'Thống kê hợp đồng' | translate }}</span></a>
                </li>-->

                <li class="nav-item nav-item-submenu">
                <li class="nav-item-divider" *ngIf="currentUser && currentUser.isAdmin()"></li>
                <li class="nav-item-header" *ngIf="currentUser && currentUser.isAdmin()">
                    <div class="text-uppercase fs-sm lh-sm opacity-50 sidebar-resize-hide">Admin</div>
                    <i class="ph-dots-three sidebar-resize-show"></i>
                </li>

                <li *ngIf="currentUser && currentUser.isAdmin()" class="nav-item nav-item-submenu">
                    <a href="javascript: void(0);" class="nav-link"
                       [ngClass]="{ active: isRouteAdminActive() }">
                        <i class="ph-gear"></i>
                        <span>{{ 'sideBar.admin' | translate }}</span>
                    </a>
                    <ul class="nav-group-sub collapse" [attr.data-submenu-title]="'sideBar.admin' | translate">
                        <li class="nav-item nav-item-submenu">
                            <a href="javascript: void(0);" class="nav-link"><i class="ph-shield-check"></i>{{ 'sideBar.adminTool' | translate }}</a>
                            <ul class="nav-group-sub collapse">
                                <li class="nav-item" *ngIf="ruleCheckerService.isAllow('admin/user/list')">
                                    <a [routerLink]="['/', 'admin', 'user', 'list']"
                                       [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: false }" class="nav-link">
                                        <i class="ph-users"></i>
                                        {{ 'sideBar.users' | translate }}
                                    </a>
                                </li>
                            </ul>
                        </li>
                        <li class="nav-item" *ngIf="currentUser && currentUser.isSuperAdmin()">
                            <a [routerLink]="['/', environment.administratorPrefix, 'role', 'search']"
                               [routerLinkActive]="'active'"
                               class="nav-link"><i class="ph-users-four"></i>{{ 'sideBar.roles' | translate }}</a>
                        </li>
                        <li class="nav-item" *ngIf="currentUser && currentUser.isSuperAdmin()">
                            <a [routerLink]="['/', environment.administratorPrefix, 'user', 'search']"
                               [routerLinkActive]="'active'"
                               class="nav-link"><i class="ph-users"></i>{{ 'sideBar.users' | translate }}</a>
                        </li>
                        <li class="nav-item" *ngIf="currentUser && currentUser.isSuperAdmin()">
                            <a [routerLink]="['/', environment.administratorPrefix, 'route', 'search']"
                               [routerLinkActive]="'active'"
                               class="nav-link"><i class="ph-path"></i>{{ 'sideBar.routes' | translate }}</a>
                        </li>
                        <li class="nav-item" *ngIf="currentUser && currentUser.isSuperAdmin()">
                            <a [routerLink]="['/', environment.administratorPrefix, 'action-log', 'search']"
                               [routerLinkActive]="'active'"
                               class="nav-link"><i class="ph ph-notebook"></i>{{ 'sideBar.logAction' | translate }}</a>
                        </li>
                    </ul>
                </li>
                <li class="nav-item-divider"></li>
                <li class="nav-item">
                    <a class="nav-link sidebar-main-resize">
                        <i class="ph-arrows-left-right"></i><span>{{ 'sideBar.showHideSidebar' | translate }}</span>
                    </a>
                </li>
                <li class="nav-item-divider d-none"></li>
            </ul>
        </div>
        <!-- /main navigation -->
    </div>
    <!-- /sidebar content -->
</div>
<!-- /main sidebar -->
